import DataTable, { Column } from "../../components/DataTable";
import Tag from "../../components/Tags";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import { formatDateTime } from "../../util/functions/UniversalFunctions";
import { fetchSubmissions } from "../../features/assignment-submission/assignmentSubmissionSlice";
import { useParams } from "react-router-dom";
import { PageHeader } from "../../components";

export default function AssignmentSubmissionList() {
  const { id } = useParams();
  const dispatch = useDispatch<AppDispatch>();
  const { submissions, loading } = useSelector(
    (state: RootState) => state.submission,
  );

  useEffect(() => {
    if (id) {
      dispatch(fetchSubmissions(id));
    }
  }, [id]);

  const columns: Column<any>[] = [
    {
      label: "SL NO.",
      accessor: "submissionId",
    },
    {
      label: "Student Name",
      accessor: "studentName",
      searchable: true,
      render: (item) => <div className="font-semibold">{item.studentName}</div>,
    },
    {
      label: "Admission No",
      accessor: "studentAdmissionNumber",
    },
    {
      label: "Submission Date",
      accessor: "submissionDate",
      render: (item) => (
        <div className="text-sm">{formatDateTime(item.submissionDate)}</div>
      ),
    },
    {
      label: "Status",
      accessor: "submissionStatus",
      render: (item) => (
        <Tag
          text={item.submissionStatus}
          color={item.submissionStatus === "SUBMITTED" ? "success" : "warning"}
        />
      ),
    },
    {
      label: "Marks",
      accessor: "marks",
      render: (item) => (
        <Tag
          text={item.marks !== null ? `${item.marks}` : "Not Graded"}
          color={item.marks !== null ? "primary" : "warning"}
        />
      ),
    },
    {
      label: "File",
      accessor: "file",
      render: (item) => {
        const fileUrl = item.submissionFileUrl;

        const isValidFile =
          fileUrl && fileUrl !== "string" && fileUrl.startsWith("http");

        return isValidFile ? (
          <a
            href={fileUrl}
            target="_blank"
            rel="noreferrer"
            className="text-blue-600 font-semibold hover:underline"
          >
            View File
          </a>
        ) : (
          <Tag text="No File" color="danger" />
        );
      },
    },
  ];

  return (
    <div className="flex flex-col gap-5">
      <div className="flex justify-between">
        <PageHeader showBack />
      </div>

      <div className="bg-white rounded-lg px-6 py-5">
        <DataTable columns={columns} data={submissions} isLoading={loading} />
      </div>
    </div>
  );
}
